import React from 'react'
import PropTypes from 'prop-types'
import { SearchProvider } from '@elastic/react-search-ui'
import SiteSearchAPIConnector from '../../lib/SiteSearchConnector'

// Connector to our Site Search API.
const connector = new SiteSearchAPIConnector({
  documentType: 'page',
  engineKey: 'S1jgssBHdk8ZtMWngK_y',
})

// Configuration for the Elastic Search provider.
const configurationOptions = {
  apiConnector: connector,
  // We don't want to run a search on initial load, but wait for user input.
  alwaysSearchOnInitialLoad: false,
  // We manage the URL state manually in the SearchPageContainer.
  trackUrlState: false,
}

/**
 * Wraps the application with the Elastic Search context provider,
 * configured with our specific API connector and options.
 * @param {React.Node} children - The child components that need access to the search context.
 */
const SearchProviderWrapper = ({ children }) => (
  <SearchProvider config={configurationOptions}>{children}</SearchProvider>
)

SearchProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
}

export default SearchProviderWrapper
